export type Project = {
  id: string
  name: string
  category: 'app' | 'web' | 'tool'
  status: 'store' | 'development'
  description: { ja: string; en: string }
  detail: { ja: string; en: string }
  technologies: string[]
  repository: string
  store?: string
  visual: 'music' | 'transfer' | 'chart' | 'mystery' | 'qr' | 'nutrition' | 'writing' | 'terminal'
}

export const projects: Project[] = [
  {
    id: 'musicfin',
    name: 'Musicfin',
    category: 'app',
    status: 'development',
    visual: 'music',
    description: { ja: '自分の音楽を、いつものように。', en: 'Your music library, wherever you are.' },
    detail: {
      ja: 'Jellyfinの音楽を楽しむiPhone・iPad向けプレイヤー。再生キューやバックグラウンド再生まで、ネイティブの使い心地を考えて開発しています。',
      en: 'A native Jellyfin music player for iPhone and iPad, with a playback queue and background audio.'
    },
    technologies: ['SwiftUI', 'AVFoundation', 'Jellyfin'],
    repository: 'https://github.com/qtmleap/Musicfin'
  },
  {
    id: 'instant-nx',
    name: 'Instant NX',
    category: 'app',
    status: 'store',
    visual: 'transfer',
    description: { ja: 'ゲームの思い出を、手元に。', en: 'Bring your gaming moments with you.' },
    detail: {
      ja: 'Nintendo Switchのアルバム共有で、写真や動画をスマートフォンへ。QRコードから接続・転送までをつなぎます。',
      en: 'Transfer screenshots and videos using Nintendo Switch album sharing, from QR scanning to Wi-Fi transfer.'
    },
    technologies: ['SwiftUI', 'NetworkExtension', 'QR Code'],
    repository: 'https://github.com/qtmleap/InstantNX',
    store: 'https://apps.apple.com/app/id6749347244'
  },
  {
    id: 'atmos',
    name: 'atmos',
    category: 'web',
    status: 'development',
    visual: 'chart',
    description: { ja: '実験の過程を、見えるかたちに。', en: 'Make the progress of experiments visible.' },
    detail: {
      ja: '機械学習のメトリクス・画像・音声・ログをまとめる実験管理ツール。ライブ更新とPython SDKを備えています。',
      en: 'An experiment tracker for metrics, images, audio and logs, with live updates and a Python SDK.'
    },
    technologies: ['React', 'Cloudflare', 'Python'],
    repository: 'https://github.com/qtmleap/atmos'
  },
  {
    id: 'alibai',
    name: 'AlibAI',
    category: 'web',
    status: 'development',
    visual: 'mystery',
    description: { ja: '会話の中に、真相がある。', en: 'The truth is in the conversation.' },
    detail: {
      ja: 'AIが演じる登場人物と会話するミステリー。シナリオの事実とAIの応答を分け、自由な会話と推理の整合性を両立させる設計です。',
      en: 'A conversational mystery with AI characters, separating scenario facts from generated dialogue.'
    },
    technologies: ['TypeScript', 'LLM', 'Cloudflare'],
    repository: 'https://github.com/qtmleap/alibai'
  },
  {
    id: 'qr-reader',
    name: 'QR Reader+',
    category: 'app',
    status: 'store',
    visual: 'qr',
    description: { ja: '読み取ることに、まっすぐ。', en: 'Simply scan. Nothing in the way.' },
    detail: {
      ja: '広告なしのQRコードリーダー。読み取り履歴と結果の確認を備えた、日常のための小さなアプリです。',
      en: 'An ad-free QR reader with scanning history and a confirmation step for results.'
    },
    technologies: ['SwiftUI', 'CodeScanner'],
    repository: 'https://github.com/qtmleap/QRReader',
    store: 'https://apps.apple.com/app/id6748316332'
  },
  {
    id: 'vitally',
    name: 'Vitally',
    category: 'web',
    status: 'development',
    visual: 'nutrition',
    description: { ja: '毎日の記録を、暮らしの味方に。', en: 'Turn everyday records into useful insights.' },
    detail: {
      ja: '食事・運動・栄養を記録するWebアプリ。AIによる推定と相談機能、認証、利用回数の管理を組み合わせています。',
      en: 'A food and exercise tracker with AI estimates, consultations, authentication and usage limits.'
    },
    technologies: ['React', 'D1', 'Workers AI'],
    repository: 'https://github.com/qtmleap/vitally'
  },
  {
    id: 'novelist',
    name: 'Novelist',
    category: 'web',
    status: 'development',
    visual: 'writing',
    description: { ja: '物語を、少しずつ育てる。', en: 'Build your story, chapter by chapter.' },
    detail: {
      ja: '登場人物・作品・章を管理するAI執筆支援。生成中の表示や本文の保存、中断時の扱いまで考えています。',
      en: 'An AI writing workspace for characters, works and chapters, with streaming and saved generation results.'
    },
    technologies: ['Gemini', 'Durable Objects', 'Prisma'],
    repository: 'https://github.com/qtmleap/novelist'
  },
  {
    id: 'local-mcp',
    name: 'local-mcp',
    category: 'tool',
    status: 'development',
    visual: 'terminal',
    description: { ja: 'AIと、開発環境をつなぐ。', en: 'Connect AI to your development environment.' },
    detail: {
      ja: 'Streamable HTTPで接続するMCPサーバー。Rust・OAuth・Dockerで、開発環境との連携を実装しています。',
      en: 'A Rust MCP server with Streamable HTTP, OAuth and Docker for development environment integrations.'
    },
    technologies: ['Rust', 'MCP', 'OAuth'],
    repository: 'https://github.com/tkgstrator/local-mcp'
  }
]
